import React, { useEffect, useRef, useState } from 'react';
import { Col } from 'react-bootstrap';
import GeoMap from '../../../event_components/geo_map';
import styles from './styles.scss';
import { LocationItem } from '../location-item/location-item';

export function MapContainer({ event, settings }) {
  const [height, setHeight] = useState('100%');
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current.clientHeight > 0) {
      setHeight(ref.current.clientHeight);
    }
  }, [height]);
  return (
    <Col xs={6} md={6} ref={ref} className={styles.mapContainer} style={{ minHeight: height }}>
      <GeoMap event={event} settings={settings} showGoogleMap />
      <LocationItem event={event} settings={settings} className={styles.locationItem} />
    </Col>
  );
}
